import script from "./SearchPermissionInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchPermissionInput.vue?vue&type=script&setup=true&lang=js"

import "./SearchPermissionInput.vue?vue&type=style&index=0&id=a8bf4894&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8bf4894"]])

export default __exports__